/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-01-04 14:43:15
 * @LastEditors: linxi
 * @LastEditTime: 2023-02-24 10:45:40
 */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-01-04 09:45:53
 * @LastEditors: linxi
 * @LastEditTime: 2023-01-04 10:50:48
 */

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootThunkApi } from '../../app/store'
import { sendAsync } from '../../app/applicationSlice'
import * as DT from '../../services/reservationChannel'

// 列表
export const getReservationChannelList = createAsyncThunk<
  void,
  DT.ReservationChannelListPrams,
  RootThunkApi<void>
>('clinic/getReservationChannelList', async (params, api) => {
  return sendAsync(DT.reservationChannelList(params), api)
})


// 保存
export const getReservationChannelEditSubmit = createAsyncThunk<
  void,
  DT.ReservationChannelEditPrams,
  RootThunkApi<void>
>('clinic/getReservationChannelEditSubmit', async (params, api) => {
  return sendAsync(DT.reservationChannelEditSubmit(params), api)
})

// ，重新绑定/解除绑定
export const getReservationChannelUpload = createAsyncThunk<
  void,
  DT.ReservationChannelUploadPrams,
  RootThunkApi<void>
>('clinic/getReservationChannelUpload', async (params, api) => {
  return sendAsync(DT.reservationChannelUpload(params), api)
})
